import checkout from "./form3";

const {
  formField3: {
    countryName,
    carrierName,
    year,
    supplementaryForThe,
    firstTime,
    vehicleName,
    taxPayerInstead,
    taxPayerInsteadId
  },
} = checkout;

const initialValues3 = {
  [countryName.name]: "",
  [carrierName.name]: "",
  [year.name]: "",
  [supplementaryForThe.name]: "",
  [firstTime.name]: false,
  [vehicleName.name]: "",
  [taxPayerInstead.name]: "",
  [taxPayerInsteadId.name]: "",
};

export default initialValues3;
